module.exports = __webpack_public_path__ + "img/candle-light.c9026617.png";